import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { BannerDto } from './dto/bannerDto';

export class BannerService extends CrudServiceBase<BannerDto> {
    constructor() {
        super(Endpoint.Banner);
        this.internalHttp = httpApi;
    }

    public async create(createBannerInput: BannerDto) {
        isUserLoggedIn();

        let newCreateBannerInput = getPartialModel(createBannerInput, [], ['id']);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreateBannerInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(updateBannerInput: BannerDto) {
        isUserLoggedIn();

        let newUpdateBannerInput = getPartialModel(updateBannerInput, [], ['lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.put(this.endpoint.Update(), newUpdateBannerInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async delete(deleteBannerInput: BannerDto) {
      isUserLoggedIn();
      
      let newDeleteBannerInput = getPartialModel(deleteBannerInput, ['id'], []);

      let result = await this.internalHttp.delete(this.endpoint.Delete(), { params: newDeleteBannerInput });
      return result.data;
    }

    public async getRouterList() {
        isUserLoggedIn();

        let result = await httpApi.get(this.endpoint.Custom(`GetRouterList`));
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportBannerService: BannerService = new BannerService();
export default exportBannerService;